import React, { memo } from 'react';
import { oneOf } from 'prop-types';

import { N200, primary } from '@/colors/colorsV1';
import Typography from '@/components/Typography';
import { styContainer, styLeftHalf, styRightHalf } from './style';
import { convertRatingStringToNumber, isOdd, MAX_RATING_NUMBER } from './helpers';

const Rating = ({ rating }) => {
  const ratingNumber = convertRatingStringToNumber(rating);
  const ratingIcons = [];
  for (let i = 1; i <= MAX_RATING_NUMBER; i += 1) {
    const color = i <= ratingNumber ? primary : N200;
    if (isOdd(i)) {
      ratingIcons.push(<div key={i} className={styLeftHalf(color)} />);
    } else {
      ratingIcons.push(<div key={i} className={styRightHalf(color)} />);
    }
  }

  return (
    <div className={styContainer} data-testid="rating">
      {ratingIcons}
      <Typography type="body" color={primary} style={{ marginTop: 0, width: 18 }}>
        {rating}
      </Typography>
    </div>
  );
};

Rating.propTypes = {
  /**
   * Value that will be display on the rating
   */
  rating: oneOf(['A', 'A-', 'B', 'B-', 'C', 'C-', 'D', 'D-', 'E', 'E-']),
};

Rating.defaultProps = {
  rating: null,
};

/**
 * Rating Component
 * a component for displaying a value of an evaluation or rating something
 * @typedef { 'A' | 'A-' | 'B' | 'B-' | 'C' | 'C-' | 'D' | 'D-' | 'E' | 'E-' } RatingProps
 * @param {{
 * rating: RatingProps
 * }} props
 * 
 * @example
 * const rating = 'B'
 * return (
 *  <Rating rating={rating}
 * )
 */
const Memo = memo(Rating);

export default Memo;
